// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";

orderDateStyles.wrapper = {
    ...xOrderInformationStyles.headingAndTextStyles?.wrapper,
};

orderDateStyles.titleText = {
    ...xOrderInformationStyles.headingAndTextStyles?.heading,
};

orderDateStyles.orderDate = {
    ...xOrderInformationStyles.headingAndTextStyles?.text,
};
